module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-4.39f9c75f.png";